import { Inject, Injectable, forwardRef, OnInit} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { Settings } from '../../settings';
import { HttpClient } from './http-client.service';
import { CachedCallService } from './cached-call.service';

@Injectable()
export class VersionService {

    private static readonly clientVersionUrl:string = `${Settings.assetUrl}/version.txt`;
    private static readonly serverVersionUrl:string = `${Settings.apiUrl}/Server/version.txt`;

    protected cachedCallService:CachedCallService = new CachedCallService();

    public clientVersion:string = "";
    public serverVersion:string = "";

    //Intentionally using Http instead of HttpClient.  We do not want to pass the Authorization header on this request
    constructor(private http:Http){
        if(Settings.displayVersions){
            this.getClientVersion();
            this.getServerVersion();
        }
    }

    public getClientVersion():Promise<string>{
        return this.cachedCallService.invokeSingleCall(
            () => {
                return this.http.get(VersionService.clientVersionUrl)
                    .toPromise()
                    .then(
                        response => {
                            this.clientVersion = response.text();
                            return this.clientVersion;        
                        }
                    );
            },
            "getClientVersion"
        );
    }
    
    public getServerVersion():Promise<string>{
        return this.cachedCallService.invokeSingleCall(
            () => {
                return this.http.get(VersionService.serverVersionUrl)
                    .toPromise()
                    .then(
                        response => {
                            this.serverVersion = response.text();
                            return this.serverVersion;        
                        }
                    );
            },
            "getServerVersion"
        );
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/version.service.ts